import { graphql } from 'gatsby';
import React from 'react';
import Blogpost from '~/templates/Blogpost/Blogpost';
import Layout from '~/components/Layout';
import SEO from '~/components/Seo';
import { toPlainText } from '~/lib/helpers';

export const query = graphql`
  query BlogPostTemplateQuery($id: String!) {
    post: sanityPost(id: { eq: $id }) {
      id
      alt
      publishedAt(formatString: "DD.MM.YYYY", locale: "nb")
      _updatedAt
      showUpdatedAt
      author {
        name
        email
      }
      title
      slug {
        current
      }
      _rawBody(resolveReferences: { maxDepth: 5 })
      _rawExcerpt(resolveReferences: { maxDepth: 5 })
      mainImage {
        asset {
          _id
          url
          path
        }
      }
    }
  }
`;

const BlogpostTemplate = (props: { data: any; errors: any }) => {
  const { data, errors } = props;
  const post = data && data.post;

  return <>{post && <Blogpost {...post} />}</>;
};

export default BlogpostTemplate;
